export const formatPrice = (number: number): string => {
  const strNumber = String(number)
  // eslint-disable-next-line prefer-named-capture-group
  const regex = /(\d)(?=(\d{3})+(?!\d))/g
  return strNumber.replace(regex, '$1 ')
}
